import { getDate } from '@/utils/date';
import {
  TNavChartPeriod,
  TNavChartTooltipLabels,
} from './InteractiveNavChart.types';

export const getPeriodTitle = (period: TNavChartPeriod) => {
  return (
    period.title ||
    getDate().locale('fa').from(getDate().subtract(period.month, 'month'), true)
  );
};

export const returnTooltipLabel = (tooltipName: TNavChartTooltipLabels) => {
  switch (tooltipName) {
    case 'stockMarket':
      return {
        title: 'بورس',
        type: 'percentage',
        isZeroValueVisible: true,
      };
    case 'fundSymbol':
      return {
        title: 'صندوق',
        type: 'percentage',
        isZeroValueVisible: true,
      };
    case 'Investment':
      return {
        title: 'ارزش دارایی',
        type: 'amount',
        isZeroValueVisible: true,
      };
    case 'Issuance':
      return {
        title: 'صدور',
        type: 'count',
        color: 'success',
      };
    case 'Redemption':
      return {
        title: 'ابطال',
        type: 'count',
        color: 'error',
      };
    case 'Reinvest':
      return {
        title: 'سرمایه گذاری مجدد',
        type: 'count',
        color: 'warning',
      };
  }
};
